<template>
  <div v-if="isOpen" class="modal fade show d-block">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="btn-close"
            @click="closeConfirmationModal"
          ></button>
        </div>
        <div class="modal-body">
          <p class="fw-bold" v-html="message"></p>
          <p v-if="item">{{ item }}</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeConfirmationModal">
            Cancel
          </button>
          <button class="btn btn-primary" @click="confirmAction">
            Confirm
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters("modal", ["confirmationModal"]),
    isOpen() {
      return this.confirmationModal.isOpen;
    },
    title() {
      return this.confirmationModal.title;
    },
    message() {
      return this.confirmationModal.message;
    },
    item() {
      return this.confirmationModal.item;
    },
    callback() {
      return this.confirmationModal.callback;
    },
  },
  methods: {
    ...mapActions("modal", ["closeConfirmationModal"]),

    confirmAction() {
      if (this.callback) {
        this.callback();
      }
      this.closeConfirmationModal();
    },
  },
};
</script>

<style scoped>
.modal.fade.show {
  display: block;
  background: rgba(0, 0, 0, 0.5);
}
</style>
